import { useRef, useEffect, useState } from 'react';
import PalmerSectionLabel from './PalmerSectionLabel';

const faqs = [
  { num: '01', q: 'What services do you offer?', a: 'We offer AI strategy, brand identity, motion direction, web design & development, digital marketing, and growth systems — all under one roof.' },
  { num: '02', q: 'What is your typical turnaround time?', a: 'Depending on scope, most projects are delivered within 7–21 days. Starter builds can be done in as little as 5 days.' },
  { num: '03', q: 'Do you only work in web design?', a: 'No — we work across brand identity, AI strategy, motion, and digital growth. Web design is one part of a broader creative offering.' },
  { num: '04', q: 'Can you handle both design and build?', a: 'Absolutely. We handle the full pipeline — from concept and design to development and launch — so nothing gets lost in translation.' },
  { num: '05', q: 'Do you offer brand strategy too?', a: 'Yes. Brand strategy is often the first step. We help define positioning, voice, and visual direction before any design work begins.' },
  { num: '06', q: 'What\'s your process like?', a: 'We start with a discovery call, then move into strategy, design, build, and launch. Every step is collaborative and transparent.' },
];

export default function PalmerFAQ() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-black py-20">
      <PalmerSectionLabel left1="© Help Center ヘルプ" left2="(WDX® — 11)" right="Clarifications" />
      <div className="px-6 grid grid-cols-1 lg:grid-cols-12 gap-12">
        {/* Left heading */}
        <div className="lg:col-span-4">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-[136px] h-[136px] overflow-hidden flex-shrink-0">
              <img src="https://framerusercontent.com/images/kDDFdQi11eufzZl2QNW6DZQPHc.png" alt="FAQ" className="w-full h-full object-cover object-top" />
            </div>
          </div>
          <h3
            className={`text-white font-semibold leading-tight transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 'clamp(22px, 2.5vw, 34px)', letterSpacing: '-0.02em' }}
          >
            Clarifying Deliverables<br />Before They Begin<br />with Real Process and<br />Honest アンサー.
          </h3>
        </div>

        {/* Right accordion */}
        <div className="lg:col-span-8">
          {faqs.map((faq, i) => (
            <div
              key={faq.num}
              className={`border-t border-white/10 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <button
                className="w-full py-5 flex items-center gap-6 text-left cursor-pointer hover:bg-white/5 transition-colors px-2"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="text-white/30 text-xs w-6 flex-shrink-0" style={{ fontFamily: "'DM Sans', sans-serif" }}>{faq.num}</span>
                <span className="text-white text-sm font-medium flex-1" style={{ fontFamily: "'DM Sans', sans-serif" }}>{faq.q}</span>
                <span className="text-white/40 text-lg flex-shrink-0 transition-transform duration-300" style={{ transform: openIndex === i ? 'rotate(45deg)' : 'rotate(0deg)' }}>+</span>
              </button>
              <div
                className="overflow-hidden transition-all duration-400"
                style={{ maxHeight: openIndex === i ? '200px' : '0px' }}
              >
                <p className="text-white/40 text-xs leading-relaxed px-2 pb-5 pl-12" style={{ fontFamily: "'DM Sans', sans-serif" }}>{faq.a}</p>
              </div>
            </div>
          ))}
          <div className="border-t border-white/10"></div>
        </div>
      </div>
    </section>
  );
}
